/* eslint-disable react/no-danger */
/* eslint-disable ordered-imports/ordered-imports */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext, useState } from "react";
import { ResolveThunks, connect, useSelector } from "react-redux";
import { css, keyframes } from "styled-components";
import Link from "@insite/mobius/Link/Link";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import { Hidden, Modal } from "@insite/mobius/index";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { ProductPriceStyles } from "@NA/Overrides/Components/ProductPrice";
import { ProductQuantityBreakPricingStyles } from "@insite/content-library/Components/ProductQuantityBreakPricing";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { TextFieldProps } from "@insite/mobius/TextField";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import getColor from "@insite/mobius/utilities/getColor";
import customLoadInventory from "@NA/Handlers/GetInventory";
import ADILocationFinder from "@NA/Components/ADILocationFinder";
import CrossIcon from "@NA/Icons/CrossIcon";
import ADIColors from "@NA/Utils/ADIColors";
import { pushDealerAuthDataToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";
import { CoveoProductContext, HasProduct, withProduct } from "@NA/Components/Coveo/Contexts/CoveoProductContext";
import CoveoProductPrice from "@NA/Components/Coveo/ProductCardView/CoveoProductPrice";
import CoveoProductListProductInformation from "@NA/Components/Coveo/ProductCardView/CoveoProductListProductInformation";
import CoveoProductListProductImage from "@NA/Components/Coveo/ProductCardView/CoveoProductListProductImage";
import CoveoProductListActions from "@NA/Components/Coveo/ProductCardView/CoveoProductListActions";
import StoreIcon from "@NA/Icons/StoreIcon";
import CoveoProductQuantityOrdered from "@NA/Components/Coveo/ProductCardView/CoveoProductQuantityOrdered";
import siteMessage from "@insite/client-framework/SiteMessage";
import Button from "@insite/mobius/Button";
import DeliveryIcon from "@NA/Icons/DeliveryIcon";
import CoveoProductSaleInfo from "@NA/Components/Coveo/ProductCardView/CoveoProductSaleInfo";
import ProductAddToCartButton from "@NA/Overrides/Components/ProductAddToCartButton";
import CoveoProductAddToCartButton from "@NA/Components/Coveo/ProductCardView/CoveoProductAddToCartButton";
import ADILBShippedByVendor from "@NA/Components/ADILBShippedByVendor";
import ADILBStorePickup from "@NA/Components/ADILBStorePickup";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";

const noAnimation = keyframes`
    from { opacity: 1; }
    to { opacity: 1; }
`;

type Props = ProductCardSelections &
    HasProduct &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    let customerNumber = "";
    const billToId = session?.billToId;
    if (billToId) {
        customerNumber = state.data.billTos.byId[billToId]?.customerNumber;
    }
    return {
        isAuthenticated: state.context.session.isAuthenticated,
        productSettings: getSettingsCollection(state).productSettings,
        cartState: getCurrentCartState(state).value,
        cartStateLoading: getCurrentCartState(state).isLoading,
        session,
        customerNumber,
    };
};

const mapDispatchToProps = {
    toggleLoginDrawer,
    customLoadInventory,
};

export interface ProductListProductCardStyles {
    gridContainer?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    quantityOrdered?: TextFieldProps;
    addToCartButton?: ButtonPresentationProps;
    rightColumnGridContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    actionsGridItem?: GridItemProps;
    searchScoreDataGridItem?: GridItemProps;
    sponsoredText?: TypographyPresentationProps;
    signInDealer?: InjectableCss;
    featuresContainer?: InjectableCss;
    features?: InjectableCss;
    featuresTitle?: TypographyProps;
    nonReturnableMsg?: InjectableCss;
    availabilityGrid?: InjectableCss;
    stockMsg?: TypographyProps;
    divider?: TypographyProps;
    availability?: TypographyProps;
    lowStockIndicator?: TypographyProps;
    stockIndicator?: TypographyProps;
    tags?: TypographyProps;
    tagsContainer?: InjectableCss;
    listDisplay?: InjectableCss;
    listDisplayWrapper?: InjectableCss;
    free?: TypographyProps;
    notFree?: TypographyProps;
    price?: ProductPriceStyles;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    addToCartWrapper?: InjectableCss;
    signInDealerPrice?: InjectableCss;
    dealerCertificateText?: InjectableCss;
    dealerText?: InjectableCss;
    dealerPriceText?: TypographyProps;
    availabilityByWarehouseModal?: ModalPresentationProps;
    variantContainer?: InjectableCss;
    isPendingVerificationSignIn?: InjectableCss;
}

export const productCardStyles: ProductListProductCardStyles = {
    addToCartWrapper: {
        css: css`
            display: flex;
            align-items: flex-end;
            margin-top: 10px;
            position: absolute;
            bottom: 0;
            height: 60px;
            width: 100%;
            left: 0;
            right: 0;
        `,
    },
    isPendingVerificationSignIn: {
        css: css`
            flex-grow: 0;
            padding-top: 35px;
            margin: 20px;
            cursor: auto;
            > div:hover {
                background-color: transparent;
                span {
                    color: ${ADIColors.darkBlue1};
                }
            }
            span {
                color: ${ADIColors.darkBlue1};
            }
        `,
    },
    availabilityByWarehouseModal: {
        sizeVariant: "medium",
        closeButtonIconProps: {
            src: CrossIcon,
            size: 20,
        },
        transition: {
            enabled: false,
            length: 0,
            overlayEntryKeyframes: noAnimation,
            overlayExitKeyframes: noAnimation,
            scrimEntryKeyframes: noAnimation,
            scrimExitKeyframes: noAnimation,
        },
        cssOverrides: {
            modalBody: css`
                max-width: 730px !important;
                border-radius: 4px;
                padding: 28px !important;
            `,
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                border-bottom: 0;
                padding: 0 !important;
                margin-bottom: 20px;
                > h4 {
                    font-size: 32px;
                    font-weight: bold;
                    font-family: "Nunito Sans", sans-serif;
                    line-height: normal;
                    color: ${ADIColors.darkBlue1};
                }
                button {
                    border-radius: 0;
                    svg {
                        height: 20px;
                    }
                }
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
    signInDealerPrice: {
        css: css`
            border-top: 1px solid ${getColor("text.disabled")};
            text-align: center;
            padding: 20px 0;
            cursor: pointer;
            transition: 0.2s ease;
            margin-top: auto;
            position: absolute;
            bottom: 0;
            width: 100%;
            left: 0;
            right: 0;
            margin-top: 30px;
            :hover {
                background-color: ${getColor("primary")};
                span {
                    color: ${ADIColors.white};
                }
            }
        `,
    },
    dealerCertificateText: {
        css: css`
            border-top: 1px solid ${getColor("text.disabled")};
            text-align: center;
            cursor: pointer;
            transition: 0.2s ease;
            margin-top: auto;
            position: absolute;
            bottom: 0;
            width: 100%;
            padding: 20px 0;
            left: 0;
            right: 0;
            margin-top: 30px;
            :hover {
                background-color: ${getColor("primary")};
                span {
                    color: ${ADIColors.white};
                }
            }
        `,
    },
    dealerText: {
        css: css`
            font-size: 16px;
            font-weight: bold;
            color: #2d2926;
            text-align: center;
        `,
    },
    dealerPriceText: {
        css: css`
            color: ${getColor("primary")};
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: bold;
        `,
    },
    addToCartButton: {
        css: css`
            width: 100%;
            border: 0;
            border-top: 1px solid ${getColor("text.disabled")};
            text-align: center;
            padding: 20px 0;
            cursor: pointer;
            transition: 0.2s ease;
            margin-top: auto;
            border-radius: 0;
            background: ${ADIColors.white};
            height: 55px;
            display: flex;
            align-items: center;
            justify-content: center;
            :disabled {
                background: ${ADIColors.white} !important;
                cursor: not-allowed;
                border-top: 1px solid ${getColor("text.disabled")} !important;
            }
            span {
                color: ${getColor("primary")};
            }
            :hover {
                background-color: ${getColor("primary")};
                span {
                    color: ${ADIColors.white};
                }
            }

            img {
                width: 40px;
            }
        `,
    },
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-right: 10px;
                width: 4.1rem;
                min-width: 4.1rem;
            `,
        },
    },
    gridContainer: {
        gap: 0,
        css: css`
            padding: 30px 0;
            min-width: 320px; /* prevent overlap with second column */
            border: 1px solid ${getColor("text.disabled")};
            border-radius: 5px;
            position: relative;
            margin: 0 0 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 30px 0 70px;
                        `,
                        css`
                            padding: 30px 0 70px;
                        `,
                        css`
                            padding: 30px 0 18px;
                        `,
                        css`
                            padding: 30px 0;
                        `,
                        css`
                            padding: 30px 0;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    quantityBreakPricing: {
        viewLink: {
            css: css`
                margin: 8px 0;
            `,
        },
    },
    price: {
        price: {
            priceText: {
                css: css`
                    flex-direction: row;
                    flex-wrap: wrap;
                    display: flex;
                    color: ${getColor("text.main")};
                    font-size: 30px;
                    sup:first-child {
                        display: inline-block;
                        margin-top: -1px;
                        font-size: 18px;
                        font-weight: 900;
                        margin-left: 0;
                        margin-right: 2px;
                    }

                    span {
                        font-size: 30px;
                        font-weight: 900;
                        line-height: 30px;
                        margin-bottom: 0px;
                        display: block;
                    }
                    sup:last-child {
                        font-weight: 900;
                        font-size: 18px;
                        font-stretch: normal;
                        line-height: normal;
                        margin-left: 2px;
                        margin-top: -1px;
                    }
                `,
            },
        },
    },
    leftColumnGridItem: {
        width: [5, 5, 3, 3, 3],
        css: css`
            padding-right: 20px;
            flex-direction: column;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-bottom: 15px;
                        `,
                        css``,
                        css``,
                        css``,
                        css``,
                    ],
                    "min",
                )}
        `,
    },
    listDisplay: {
        css: css`
            display: flex;
            align-items: flex-start;
            margin-top: 10px;
            font-weight: bold;
            svg {
                margin-right: 7px;
            }
            span {
                font-size: 12px;

                color: ${ADIColors.darkBlue1};
                display: block;
            }
        `,
    },
    listDisplayWrapper: {
        css: css`
            margin-bottom: 20px;
            //min-height: 80px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        min-height: initial;
                        margin-bottom: 10px;
                    `,
                    css`
                        min-height: initial;
                        margin-bottom: 10px;
                    `,
                    css`
                        margin-bottom: 20px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    free: {
        css: css`
            color: ${ADIColors.lightGreen1} !important;
        `,
    },
    notFree: {
        css: css`
            color: ${ADIColors.orange1} !important;
        `,
    },

    rightColumnGridItem: {
        width: [7, 7, 9, 9, 9],
    },
    infoGridItem: {
        width: [12, 12, 6, 7, 7],
        css: css`
            flex-direction: column;
        `,
    },
    actionsGridItem: {
        width: [0, 0, 6, 5, 5],
        css: css`
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
        `,
    },
    searchScoreDataGridItem: {
        width: 12,
    },
    sponsoredText: {
        css: css`
            margin-bottom: 5px;
            font-size: 0.9em;
            opacity: 0.5;
        `,
    },
    signInDealer: {
        css: css`
            margin-right: auto;
            font-size: ${getProp("theme.typography.h6.size")};
            border-radius: 4px;
            min-height: 40px;
            height: auto;
            align-items: center;
            display: flex;
            justify-content: center;
            padding: 10px 20px;
            border: solid 1px ${getColor("secondary")};
            color: ${getColor("secondary")};
            font-weight: bold;
            transition: 0.2s ease;
            cursor: pointer;
            :hover {
                color: ${ADIColors.white};
                background-color: ${getColor("secondary")};
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css``,
                        css``,
                        css`
                            padding: 3px 20px;
                            margin-top: 50px;
                            text-align: center;
                            margin-right: 15px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    featuresContainer: {
        css: css`
            margin-bottom: 2rem;
            margin-left: -5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-bottom: 10px;
                            line-height: normal;
                        `,
                        css`
                            margin-bottom: 10px;
                            line-height: normal;
                        `,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    features: {
        css: css`
            ul {
                padding-left: 25px;
                margin-top: 11px;
                margin-bottom: 45px;
            }
            li {
                font-weight: 400;
                font-stretch: normal;
                font-style: normal;
                line-height: 22px;
                letter-spacing: normal;
                font-size: ${getProp("theme.typography.headerSecondary.size")};
                color: ${ADIColors.gray4};
                padding-bottom: 0;
                list-style: disc;
            }
        `,
    },
    featuresTitle: {
        as: "h3",
        css: css`
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            margin-top: 11px;
            margin-bottom: 10px;
            line-height: normal;
            color: ${ADIColors.darkBlue1};
            font-weight: 700;
        `,
    },
    availabilityGrid: {
        css: css`
            bottom: 1rem;
            top: auto;
            order: initial;
            margin-bottom: 0;
            position: absolute;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            bottom: auto;
                        `,
                        css`
                            bottom: auto;
                        `,
                        css`
                            order: 4;
                        `,
                        css`
                            position: relative;
                            margin-top: 30px;
                        `,
                        null,
                    ],
                    "max",
                )}
            > span {
                margin-right: 10px;
            }
        `,
    },
    stockMsg: {
        css: css`
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: 600;
            color: ${ADIColors.black};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: none;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    availability: {
        css: css`
            font-size: ${getProp("theme.typography.h6.size")};
            a:hover {
                text-decoration: underline;
            }
            span {
                font-size: ${getProp("theme.typography.h6.size")};
                font-weight: bold;
                display: inline;
                margin-top: 0px;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                                font-size: ${getProp("theme.typography.headerSecondary.size")};
                                display: block;
                                margin-top: 6px;
                            `,
                        css``,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )}
            }
        `,
    },
    divider: {
        css: css`
            color: ${ADIColors.gray3};
            display: inline;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: none;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    lowStockIndicator: {
        css: css`
            width: 10px;
            height: 10px;
            display: inline-block;
            background: ${ADIColors.warningDot};
            border-radius: 50%;
            margin-right: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        css``,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    stockIndicator: {
        css: css`
            width: 10px;
            height: 10px;
            display: inline-block;
            background: ${ADIColors.lightGreen1};
            border-radius: 50%;
            margin-right: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        css``,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    tags: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            padding: 4px 15px !important;
            background-color: ${ADIColors.newPrimary};
            flex-grow: 0;
            font-size: 12px;
            font-weight: 800;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: ${ADIColors.white};
            border-radius: 0;
            border-top-left-radius: 5px;
            border-bottom-right-radius: 5px;
            min-height: 24px;
            width: auto;
            line-height: 1;
            white-space: normal;
            height: auto;
        `,
    },
    tagsContainer: {
        css: css`
            position: absolute;
            top: 0;
            left: 0;
        `,
    },
    variantContainer: {
        css: css`
            width: 100%;
            position: relative;
            margin-top: 1rem;
            margin-right: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css``,
                        css``,
                        css`
                            padding: 1rem 0;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
            span {
                color: #002856;
                font-size: 12px;
                font-weight: bold;
            }
        `,
    },
};

const styles = productCardStyles;

const CoveoProductListProductCard: FC<Props> = props => {
    const coveoProduct = props.coveoProduct;
    const freeShippingAmount = Number(props.session.properties.freeshipThresholdAmt);
    const coveoProductContext = useContext(CoveoProductContext);
    const coveoProductInfo = coveoProductContext?.coveoProductInfo;
    const pricing = coveoProductInfo?.pricing || coveoProduct.pricing;
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [inventoryResult, setInventoryResult] = React.useState<any>(null);
    const [dealerModalIsOpen, setDealerModalIsOpen] = React.useState(false);
    const isPendingVerification = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isPendingVerification,
    );
    const openSignIn = () => {
        props.toggleLoginDrawer({
            loginDrawer: true,
        });
    };

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };

    const getCertified = () => {
        setDealerModalIsOpen(true);
    };

    const dealerModalCloseHandler = () => {
        setDealerModalIsOpen(false);
    };

    const viewAvailabilityByWarehouseClickHandler = () => {
        setModalIsOpen(true);

        props.customLoadInventory({
            productId: coveoProduct.productNumber,
            onSuccess(result: any) {
                setInventoryResult(result);
            },
        } as any);
    };

    const renderedFeatureBullets1to3HTML = { __html: coveoProduct.featureBullets1to3 ?? "" };

    const carLineItem = props.cartState?.cartLines?.find(cartLine => cartLine.erpNumber === coveoProduct.productNumber);

    const showAuthorizationRequired = !!(
        pricing &&
        pricing.additionalResults &&
        pricing.additionalResults.isVisible &&
        pricing.additionalResults.isVisible === "N"
    );
    // const vendorAuthRequiredList = product?.properties?.vendorAuthRequiredList;
    const vendorAuthRequiredList = coveoProduct.vendorAuthRequiredList === "true";

    const brandName = coveoProduct.brandName;
    // const vendorAuthRequiredLink = product?.properties?.vendorAuthRequiredLink;
    const vendorAuthRequiredLink = coveoProduct.vendorAuthRequiredLink;

    const clickHandler = () => {
        pushDealerAuthDataToDataLayer(
            brandName,
            vendorAuthRequiredLink,
            props.customerNumber,
            "Product List",
            props.session,
        );
    };

    const adiNumberCustomStyles = () => css`
        padding: 0 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-wrap: wrap;
        font-size: 10px;
        text-align: center;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-bottom: ${props.isAuthenticated ? "20px" : "35px"};
                    font-size: 12px;
                `,
                null,
                null,
                css`
                    display: none;
                `,
                css`
                    display: none;
                `,
            ])}
        >span {
            color: ${ADIColors.gray4};
            font-weight: 600;
            line-height: normal;
            text-transform: uppercase;
        }
    `;

    const isLbCoveoProduct = coveoProduct?.logicBroker?.toLowerCase() === "yes";
    const isPRRegion = typeof window !== 'undefined' && window.location.hostname.endsWith(".pr");

    return (
        <GridContainer
            {...styles.gridContainer}
            data-test-selector={`productListProductCard${props.coveoProduct.productId}`}
        >
            <CoveoProductSaleInfo product={coveoProduct} isAuthenticated={props.isAuthenticated} />
            <GridItem {...styles.leftColumnGridItem}>
                {/* {props.product.isSponsored && (
                    <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>
                )} */}
                <StyledWrapper>
                    <CoveoProductListProductImage showImage={props.showImage} showCompare={props.showCompare} />
                    <StyledWrapper css={adiNumberCustomStyles()}>
                        <Typography>{props.coveoProduct.manufacturerItem}</Typography>
                        <Typography>{props.coveoProduct.productNumber}</Typography>
                    </StyledWrapper>
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.rightColumnGridItem}>
                <GridContainer {...styles.rightColumnGridContainer}>
                    <GridItem {...styles.infoGridItem}>
                        <CoveoProductListProductInformation
                            showBrand={props.showBrand}
                            showTitle={props.showTitle}
                            showPartNumbers={props.showPartNumbers}
                            showAvailability={props.showAvailability}
                            showAttributes={props.showAttributes}
                        />
                        <Hidden below="lg">
                            {coveoProduct.featureBullets1to3 ? (
                                <StyledWrapper {...styles.featuresContainer}>
                                    <Typography {...styles.featuresTitle}>{translate("Key Features")}</Typography>
                                    <StyledWrapper {...styles.features}>
                                        <div dangerouslySetInnerHTML={renderedFeatureBullets1to3HTML}></div>
                                    </StyledWrapper>
                                </StyledWrapper>
                            ) : null}
                        </Hidden>

                        {showAuthorizationRequired ? null : (
                            <>
                                <Hidden above="sm">
                                    {props.isAuthenticated && props.showPrice && coveoProductContext && (
                                        <>
                                            <CoveoProductPrice
                                                showLabel={false}
                                                showSavings={true}
                                                showSavingsAmount={props.productSettings.showSavingsAmount}
                                                showSavingsPercent={props.productSettings.showSavingsPercent}
                                                extendedStyles={styles.price}
                                                coveoProduct={coveoProductContext}
                                            />
                                            {/* <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} /> */}
                                        </>
                                    )}
                                </Hidden>
                                <Hidden above="md">
                                    {props.isAuthenticated && !isPRRegion ? (
                                        <StyledWrapper {...styles.listDisplayWrapper}>
                                            <ADILBStorePickup isLbProduct={isLbCoveoProduct} />
                                            <StyledWrapper {...styles.listDisplay}>
                                                <DeliveryIcon />
                                                <StyledWrapper>
                                                    <Typography>{translate("Delivery")}</Typography>
                                                    {((Number(coveoProduct?.pricing?.unitNetPrice) !== 0 && coveoProduct?.pricing?.unitNetPrice != null) ?
                                                        <Typography
                                                            {...(coveoProduct.pricing &&
                                                                coveoProduct.pricing.unitNetPrice >= freeShippingAmount
                                                                ? styles.free
                                                                : styles.notFree)}
                                                        >
                                                            {coveoProduct.pricing &&
                                                                coveoProduct.pricing.unitNetPrice >= freeShippingAmount
                                                                ? translate("Free")
                                                                : translate(
                                                                    `Free for orders $${freeShippingAmount} & above`,
                                                                )}
                                                        </Typography>
                                                        : <Typography></Typography>
                                                    )}
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    ) : null}
                                </Hidden>
                                <StyledWrapper {...styles.nonReturnableMsg}>
                                    {coveoProduct.classificatioN_CODE === "N" ? (
                                        <StyledWrapper {...styles.featuresContainer}>
                                            {translate("PRODUCT IS NON-RETURNABLE")}
                                        </StyledWrapper>
                                    ) : null}
                                </StyledWrapper>
                                {props.isAuthenticated &&
                                    (isLbCoveoProduct ? (
                                        <ADILBShippedByVendor vendorName={brandName} view="list" />
                                    ) : !coveoProduct.availability?.toString()?.includes("Special Order") ? (
                                        <StyledWrapper {...styles.availabilityGrid}>
                                            <Typography {...styles.stockMsg}>
                                                {!coveoProduct.availability?.toString()?.includes("DISCONTINUED") ? (
                                                    <Typography
                                                        {...(coveoProduct.availability?.toString()?.includes("In Stock")
                                                            ? styles.stockIndicator
                                                            : styles.lowStockIndicator)}
                                                    ></Typography>
                                                ) : null}
                                                {coveoProduct.availability?.toString()?.includes("In Stock")
                                                    ? translate("Stock Available")
                                                    : translate("Low Stock")}
                                            </Typography>
                                            <Typography {...styles.divider}>|</Typography>
                                            <Typography {...styles.availability}>
                                                <Link onClick={viewAvailabilityByWarehouseClickHandler}>
                                                    {translate("Stock Availability")}
                                                </Link>
                                            </Typography>
                                            <Modal
                                                {...styles.availabilityByWarehouseModal}
                                                headline={translate("Stock Availability")}
                                                isOpen={modalIsOpen}
                                                handleClose={modalCloseHandler}
                                            >
                                                <ADILocationFinder
                                                    productId={coveoProduct.productNumber}
                                                    warehouseDetails={inventoryResult}
                                                />
                                            </Modal>
                                        </StyledWrapper>
                                    ) : (
                                        <StyledWrapper {...styles.availabilityGrid}>
                                            {translate("Special Order")}
                                        </StyledWrapper>
                                    ))}
                            </>
                        )}
                        <Hidden above="sm">
                            {coveoProduct.variantTypeId && (
                                <StyledWrapper {...styles.variantContainer}>
                                    <Typography>More Options Available</Typography>
                                </StyledWrapper>
                            )}
                        </Hidden>
                    </GridItem>

                    <GridItem {...styles.actionsGridItem}>
                        {!props.isAuthenticated ? (
                            <>
                                <StyledWrapper {...styles.signInDealer} onClick={openSignIn}>
                                    <Typography as="span">{translate("Sign In for Dealer Pricing")}</Typography>
                                </StyledWrapper>
                                {coveoProduct.variantTypeId && (
                                    <StyledWrapper {...styles.variantContainer}>
                                        <Typography>More Options Available</Typography>
                                    </StyledWrapper>
                                )}
                            </>
                        ) : null}
                        {props.isAuthenticated && !isPendingVerification ? (
                            <CoveoProductListActions showPrice={props.showPrice} showAddToList={props.showAddToList} />
                        ) : null}
                    </GridItem>
                    <Hidden above="sm">
                        {!isPendingVerification && props.isAuthenticated ? (
                            <>
                                {!showAuthorizationRequired ? (
                                    <StyledWrapper {...styles.addToCartWrapper}>
                                        {carLineItem?.qtyOrdered && (
                                            <CoveoProductQuantityOrdered
                                                cartLine={carLineItem}
                                                extendedStyles={styles.quantityOrdered}
                                                variant="product listing grid"
                                                cartStateLoading={props.cartStateLoading}
                                            />
                                        )}
                                        <CoveoProductAddToCartButton
                                            data-test-selector={`actionsAddToCart${coveoProductContext?.coveoProduct.productId}`}
                                            extendedStyles={styles.addToCartButton}
                                            btnIsHidden={!!carLineItem?.qtyOrdered}
                                        />
                                    </StyledWrapper>
                                ) : vendorAuthRequiredList ? (
                                    <StyledWrapper {...styles.dealerCertificateText}>
                                        <StyledWrapper {...styles.dealerText}>
                                            Dealer Certification Required
                                            <br />
                                            <Link onClick={getCertified}>Get Certified</Link>
                                        </StyledWrapper>

                                        <Modal
                                            {...styles.availabilityByWarehouseModal}
                                            headline={translate("Dealer Certification Required")}
                                            isOpen={dealerModalIsOpen}
                                            handleClose={dealerModalCloseHandler}
                                        >
                                            {siteMessage("Dealer_Vendor_Certification_Message")}
                                            <Link
                                                href={coveoProduct.vendorAuthRequiredLink}
                                                target="_blank"
                                                onClick={clickHandler}
                                            >
                                                {" "}
                                                {translate("vendor's form.")}
                                            </Link>{" "}
                                            {translate("For more information, call ")}
                                            <StyledWrapper as="span">1.877.228.6739.</StyledWrapper>
                                            <Button onClick={dealerModalCloseHandler}>Continue Shopping</Button>
                                        </Modal>
                                    </StyledWrapper>
                                ) : (
                                    <StyledWrapper>
                                        <StyledWrapper>Dealer Certification Required</StyledWrapper>
                                        <Link onClick={getCertified}>Get Certified</Link>

                                        <Modal
                                            {...styles.availabilityByWarehouseModal}
                                            headline={translate("Dealer Certification Required")}
                                            isOpen={dealerModalIsOpen}
                                            handleClose={dealerModalCloseHandler}
                                        >
                                            {siteMessage("Dealer_Certification_Message")}
                                            <Button onClick={dealerModalCloseHandler}>Continue Shopping</Button>
                                        </Modal>
                                    </StyledWrapper>
                                )}
                            </>
                        ) : (
                            <StyledWrapper {...styles.signInDealerPrice} onClick={openSignIn}>
                                <Typography {...styles.dealerPriceText} as="span">
                                    {!isPendingVerification
                                        ? translate("Sign In for Dealer Pricing")
                                        : translate("Account Pending Verification")}
                                </Typography>
                            </StyledWrapper>
                        )}
                    </Hidden>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProduct(CoveoProductListProductCard));
